<script setup>

const { locale } = useI18n()

const route = useRoute()
const audioId = ref(route.params.audio)
const track = ref(null)

const props = defineProps({
	album: {
    type: Object,
  },
	tracklistUrl: {
		type: String
	},
	color: {
		type: String,
		default: 'red'
	},
	isInTracklist: {
		type: Boolean,
		default: false
	},
	isOnlyTrack: {
		type: Boolean,
		default: false
	}
})

const findTrack = (tracklist) => {
	tracklist.discs.forEach(disc => {
		disc.songs.forEach(song => {
			if(song.tracks.find(item => item.supraphonlineId === parseInt(audioId.value))) {
				track.value = song.tracks.find(item => item.supraphonlineId === parseInt(audioId.value))
			}
		});
	});
}

onMounted(async () => {
	const result = await useUIFetch(locale.value, props.tracklistUrl)

	if(props.isInTracklist) {
		if(result) {
			findTrack(result)
		}
	} else if (props.isOnlyTrack) {
		track.value = result.body.find(item => item.component === 'Track')
	} else {
		track.value = result
	}
})

</script>

<template>
	<div>
		<ClientOnly>
			<div class="dark:bg-dark8 bg-lightBg8 dark:text-light mb-14 xl:mb-24">
				<div class="p-4 md:p-10">
					<div class="xl:flex items-center gap-10">
						<NuxtImg :src="album.image?.url" class="md:max-w-60 mb-6 xl:mb-0 w-full" />
						<div class="grow-1 w-full">
							<h3 class="mb-3" :class="`text-${color}`">{{ album.artistdisplay }}</h3>
							<h5 class="mb-4 xl:mb-6">{{ album.title }}</h5>
							<div v-if="track?.perex" class="dark:text-light mb-4 xl:mb-6 text-sm xl:text-lg" v-html="track?.perex" />
							<AudioPlayer v-if="track" :track="track" />
						</div>
					</div>
				</div>
			</div>
		</ClientOnly>
	</div>
</template>